var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlashcardLightGreyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.05822 1.28466C9.10194 1.13224 9.208 1.00237 9.35316 0.923507C9.49831 0.844642 9.67072 0.823214 9.83261 0.863917L17.8564 2.88848C18.0187 2.92914 18.1571 3.02885 18.2414 3.16569C18.3256 3.30253 18.3487 3.46529 18.3056 3.61818L15.2267 14.4418C15.183 14.5945 15.0767 14.7246 14.9313 14.8035C14.7858 14.8824 14.613 14.9037 14.451 14.8626L6.42716 12.838C6.26516 12.7971 6.12702 12.6972 6.04306 12.5604C5.95909 12.4236 5.93617 12.261 5.97932 12.1083L9.05822 1.28466Z",
    stroke: "#B5B5B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.47466 3.39209L1.46915 5.1617C1.30716 5.20263 1.16901 5.30245 1.08505 5.43926C1.00109 5.57607 0.978164 5.73868 1.02131 5.8914L4.09755 16.715C4.14126 16.8677 4.24752 16.9978 4.39298 17.0767C4.53844 17.1556 4.7112 17.1769 4.87327 17.1358L8.88518 16.1235",
    stroke: "#B5B5B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashcardLightGreyIcon);
export default __webpack_public_path__ + "static/media/flashcard-light-grey-icon.666981f778aaa376796713505319370c.svg";
export { ForwardRef as ReactComponent };